module.exports = __webpack_public_path__ + "media/images/home-page/1-1-15b69ee39252bc998225fc46a706df16.png";